var Marionette = require('backbone.marionette');

var MergePersonsDetailView = require('./merge-persons-detail-view');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var MergePersonsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-persons-view.html'),

    regions: {
        mergeFromPerson: '#merge-from-person-select',
        mergeToPerson: '#merge-to-person-select',
        mergeDetailsRegion: '#merge-details'
    },

    ui: {
        mergeFromPersonSelect: '#merge-from-person-select',
        mergeToPersonSelect: '#merge-to-person-select',
        mergeFromPersonProbables: '#merge-from-person-select-probables',
        mergeToPersonProbables: '#merge-to-person-select-probables',
        mergeDetailsShow: '#show-merge-details',
        mergeFromPersonsFilterSelect: '#merge-from-persons-filter',
        personsSelectForm: '#persons-select-form',
        mergeDetailsContainer: '#merge-details',
        reset: '#reset'
    },

    events: {
        'click @ui.mergeDetailsShow': 'onMergeDetailsShowClick',
        'change @ui.mergeFromPersonsFilterSelect': 'onMergeFromPersonsFilterChange',
        'click @ui.reset': 'onResetSelects'
    },

    childViewEvents: {
        'back:to:select': 'onBackToSelect',
        'suggestor:selected:fromperson': 'onSelectedFromPerson',
        'suggestor:selected:toperson': 'onSelectedToPerson'
    },

    constants: {
        maxNumberOfItemsInControlWithSuggester: 20
    },

    vars: {
        mergeFromPersonsGetUrl: '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~',
        mergeToPersonsGetUrl: '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~'
    },

    initialize: function (options) {
        this.ids = {
            mergeFromPersonId: options.mergeFrom,
            mergeToPersonId: options.mergeTo
        };
        this.mergeFromPersonInputId = 'merge-from-person-input';
        this.mergeToPersonInputId = 'merge-to-person-input';
    },


    onRender: function () {
        window.document.title = "Merge persons";
        var that = this;

        var mergableFromSelectize = that.ui.mergeFromPersonsFilterSelect.selectize({
            allowEmptyOption: false,
            placeholder: 'Select merge from persons filter',
            inputClass: 'form-control selectize-input normal-width',
            valueField: 'value',
            labelField: 'name',
            searchField: ['name', 'value']
        });

        if (!_.isEmpty(that.ids.mergeFromPersonId) && !_.isEmpty(that.ids.mergeToPersonId)) {
            that.onMergeDetailsShowClick(false);

        } else {
            that.showMergeFromPersonSelect();
            that.showMergeToPersonSelect();
            that.ui.personsSelectForm.collapse('show');
        }

    },

    showMergeFromPersonSelect: function () {
        var that = this;

        that.showChildView('mergeFromPerson', new RemoteSuggesterView({
            inputId: that.mergeFromPersonInputId,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: that.vars.mergeFromPersonsGetUrl,
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Merge from person",
            findSelectedIdBySelectedIndex: that.findSelectedIdBySelectedIndex,
            tag: 'fromperson'
        }));
    },

    showMergeToPersonSelect: function () {
        var that = this;

        that.showChildView('mergeToPerson', new RemoteSuggesterView({
            inputId: that.mergeToPersonInputId,
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: that.vars.mergeToPersonsGetUrl,
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Merge to person",
            findSelectedIdBySelectedIndex: that.findSelectedIdBySelectedIndex,
            tag: 'toperson'
        }));
    },

    onMergeDetailsShowClick: function (witBack) {
        var that = this;

        if (that.ids["mergeFromPersonId"] == that.ids["mergeToPersonId"]) {
            notificationsChannel.request('show:notification', 'Selected "merge from" and "merge to" persons are same user');
            return;
        }

        $.when(
            $.ajax({
                type: "GET",
                url: '/api/person/' + that.ids["mergeFromPersonId"]
            }),
            $.ajax({
                type: "GET",
                url: '/api/medprofile/person/' + that.ids["mergeFromPersonId"]
            }),
            $.ajax({
                type: "GET",
                url: '/api/person/' + that.ids["mergeToPersonId"]
            }),
            $.ajax({
                type: "GET",
                url: '/api/medprofile/person/' + that.ids["mergeToPersonId"]
            })
        ).then(
            function (mergeFromPersonResponse, mergeFromPersonMedProfileResponse, mergeToPersonResponse, mergeToPersonMedProfileResponse) {

                that.showChildView('mergeDetailsRegion', new MergePersonsDetailView({
                    mergeFromPerson: mergeFromPersonResponse[0],
                    mergeFromPersonMedProfile: mergeFromPersonMedProfileResponse[0],
                    mergeToPerson: mergeToPersonResponse[0],
                    mergeToPersonMedProfile: mergeToPersonMedProfileResponse[0],
                    withBack: witBack ? true : false
                }));

                that.ui.personsSelectForm.collapse('hide');
                that.ui.mergeDetailsContainer.collapse('show');
            },
            function (error, text, status) {

                if (error.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else if (error.status == 404) {
                    notificationsChannel.request('show:notification',
                        'Error. Not found medical profile for either "merge from" or "merge to" person. Please, check medical profiles.');
                } else {
                    notificationsChannel.request('show:notification',
                        'Error. Try later');
                }

            }
        );
    },

    onMergeFromPersonsFilterChange: function (event) {
        if (event.target.value == 'mergeble') {
            this.vars.mergeFromPersonsGetUrl = '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&object_mergeable=true&like_name=~~~';
            this.showMergeFromPersonSelect();
        }
        else {
            this.vars.mergeFromPersonsGetUrl = '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~';
            this.showMergeFromPersonSelect();
        }

        this.ids.mergeFromPersonId = null;
        this.ui.mergeFromPersonProbables.empty();
        this.validate();
    },

    onBackToSelect: function () {
        this.ui.personsSelectForm.collapse('show');
        this.ui.mergeDetailsContainer.collapse('hide');
    },

    findSelectedIdBySelectedValue: function (arr, value) {
        var found = _.findWhere(arr, {name: value});
        return found ? found.id : null;
    },

    findSelectedIdBySelectedIndex: function (arr, index) {
        return (arr[index] || {}).id;
    },

    onSelectedFromPerson: function (id) {
        var that = this;
        that.ids["mergeFromPersonId"] = id;
        this.ui.mergeFromPersonProbables.empty();

        if (that.ids["mergeToPersonId"])
            that.validate();
        else {
            that.renderLocalSuggester(id, that.ui.mergeToPersonProbables, "merge-to-probable-selectize", "mergeToPersonId", that.mergeToPersonInputId);
        }
    },

    onSelectedToPerson: function (id) {
        var that = this;
        that.ids["mergeToPersonId"] = id;
        this.ui.mergeToPersonProbables.empty();

        if (that.ids["mergeFromPersonId"])
            that.validate();
        else {
            that.renderLocalSuggester(id, that.ui.mergeFromPersonProbables, "merge-from-probable-selectize", "mergeFromPersonId", that.mergeFromPersonInputId);
        }
    },

    renderLocalSuggester: function (id, target, targetSelectId, idKey, suggestorInputId) {
        var that = this;

        $.when(
            $.ajax({
                type: "GET",
                url: '/api/person/' + id
            })
        ).done(function (response) {

            var params = [];
            if (response.object.firstName)
                params.push("firstName=" + response.object.firstName);
            if (response.object.lastName)
                params.push("lastName=" + response.object.lastName);
            if (response.object.middleName)
                params.push("middleName=" + response.object.middleName);
            if (response.object.birthData)
                params.push("birthDate=" + response.object.birthData);
            if (response.object.npi)
                params.push("npi=" + response.object.npi);
            if (response.object.ssn)
                params.push("ssn=" + response.object.ssn);
            if (response.object.insuranceId)
                params.push("insuranceId=" + response.object.insuranceId);

            $.when(
                $.ajax({
                    type: "GET",
                    url: '/api/person/mpi/all?' + params.join('&')
                })
            ).done(function (list) {
                var persons = list.filter(function(item) {
                    return item.id != id;
                });
                if (persons.length > 0) {
                    that.renderLocalSuggesterRegion(persons, target, targetSelectId, idKey, suggestorInputId);
                }
            });

        });
    },

    validate: function () {
        if (this.ids["mergeFromPersonId"] && this.ids["mergeToPersonId"])
            this.ui.mergeDetailsShow.removeAttr('disabled');
        else
            this.ui.mergeDetailsShow.attr('disabled', true);
    },

    renderLocalSuggesterRegion: function(persons, target, targetSelectId, idKey, suggestorInputId) {
        var that = this;
        target.empty();
        var options = persons.map(function(item) {
            return "<option value='" + item.id + "'>" + item.name + "</option>";
        });
        target.append("<select id='" + targetSelectId + "'><option value=''></option>" + options.join('') + "</select>");
        $('#' + targetSelectId).selectize({
            allowEmptyOption: false,
            inputClass: 'form-control selectize-input normal-width form-control',
            highlight: true,
            openOnFocus: true,
            placeholder: 'Probable matches'
        });
        $('#' + targetSelectId).on('change', function(e) {
            $('#' + suggestorInputId).val(e.target.innerText);
            that.ids[idKey] = e.target.value;
            that.validate();
        })
    },

    onResetSelects: function() {
        this.ui.mergeFromPersonProbables.empty();
        this.ui.mergeToPersonProbables.empty();
        this.getChildView('mergeFromPerson').render();
        this.getChildView('mergeToPerson').render();
        this.ids = {
            mergeFromPersonId: null,
            mergeToPersonId: null
        };
        this.validate();
    }
});

module.exports = MergePersonsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-persons-view.js
// module id = 476
// module chunks = 0